export const resumeData = {
    "name": "RYAN LIM CHIN WEE",
    "title": "ASPIRING SOFTWARE ENGINEER",
    "contact": {
        "phone": "(+65) 12345678",
        "email": "rryanlimcw@gmail.com",
        "linkedin": "https://linkedin.com/in/ryanlimcw",
        "github": "https://github.com/Seibell"
    },
    "objective": "Seeking a 3-month internship opportunity from 08 May 2023 onwards to learn and gain experience in the software development industry.",
    "skills": {
        "softSkills": ["Teamwork", "Problem Solver", "Perseverance", "Self starter"],
        "backend": ["Java", "Python", "Rest API", "MySQL", "MongoDB", "Airflow", "Go", "Git"],
        "frontend": ["JavaScript (React JS)", "HTML5 & CSS", "PrimeFaces & JSF", "jQuery"],
        "dataAnalytics": ["Tableau"]
    },
    "about": "Passionate and driven Information Systems student from the National University of Singapore. Experienced in full-stack web development and data analysis. Looking for new challenges to grow both as a software engineer and as a leader.",
    "education": {
        "degree": "BACHELOR OF COMPUTING IN INFORMATION SYSTEMS",
        "school": "National University of Singapore (NUS)",
        "location": "Singapore",
        "duration": "2021 – 2025",
        "coursework": [
            "Data Structures & Algorithms",
            "Database Management & Visualization",
            "Java OOP",
            "Web Applications",
            "Enterprise System Design & Development",
            "Software Development",
            "Data Engineering",
            "Business Analytics"
        ]
    },
    "achievements": [
        "Top student in class of 115 students for Database and Data Visualization (AY22-23 SEM1)",
        "NYJC Academic Excellence Award – Dean’s List for 2018 – 4 H2 Distinctions for GCE ‘A’ Level",
        "Singapore Representative for International Esports Festival Korea 2021 and 2022"
    ],
    "projects": [
        {
            "name": "MealNUS (Full-Stack Web App)",
            "duration": "Jan 2023 – Apr 2023",
            "description": "Leading a team of 6 to develop a solution to unhealthy campus eating habits: organized meetings, delegated tasks and provided technical assistance. Implemented customer interface for CRUD operations on entities using ReactJS, EJB and MySQL"
        },
        {
            "name": "Plutus Expense Tracking (Android App)",
            "duration": "May 2022 – Aug 2022",
            "description": "Led a team of 2 to develop a novel solution to personal expense tracking. By utilizing features such as dashboard analytics and push notifications, we generated 34 downloads in a period of 2 weeks."
        }
    ],
    "workExperience": [
        {
            "position": "Teacher",
            "company": "Franstars Learning Café",
            "duration": "Mar 2021 – Jan 2022",
            "responsibilities": [
                "Promoted after 1-month as an assistant teacher",
                "Planned and executed on lessons for groups of 2-4 students",
                "Provided students with an open channel to receive feedback on assignments and content until they achieve 100% mastery",
                "Reassured parents and administration via consistent progress reports and updates on student progress"
            ]
        }
    ]
};  